export const colorsList = {
  red: "#D32F2F",
  yellow: "#FBC02D",
  lightYellow: "#FFFF00",
  blue: "#0D47A1",
  green: "#4CAF50",
  darkGreen: "#27742aff",
  lightGreen: "#9be59e",
  lightGreen2: "#CEF2D2",
  violet: "#8c00b6",
  purple: "#3900b2",
  orange: "#EF6C00",
  darkGrey: "#878787",
  lightGrey: "#F3F3F3",
  grey: "#A9A9A9",
  white: "#ffffff",
  black: "#2e2e2e",
  golden: "#FFD700",
  turquoise: "#009688",
  pink: "#D8A7B1",
};
